// Import the Signup component from the auth components folder
import Signup from '../components/auth/Signup';

// Functional component representing the Signup page
function SignupPage() {
  return (
    // Container div for consistent padding and centered layout
    <div className="container mx-auto p-4">
      {/* Render the Signup form component */}
      <Signup />
    </div>
  );
}
// Export the SignupPage component as default for use in routes
export default SignupPage;
